export function pad(d: number) {
    return (d < 10) ? '0' + d.toString() : d.toString();
}

export function sleep(ms: number): Promise<void> {
    return new Promise(r => setTimeout(r, ms));
}
